import { Observable } from 'rxjs/Observable';

import catchAndReport from './rxjs.operator.catchAndReport';

if (!Observable.prototype.catchAndReport) {
  Observable.prototype.catchAndReport = catchAndReport;
}
